export const getOperators = t => [
  { id: 'eq', name: t('operator.equal') },
  { id: 'neq', name: t('operator.notEqual') },
  { id: 'gt', name: t('operator.greaterThan') },
  { id: 'lt', name: t('operator.lessThan') },
  { id: 'lte', name: t('operator.lessThanOrEqual') },
  { id: 'gte', name: t('operator.greaterThanOrEqual') }
]

export const INTERPOLATIONS = [
  { name: 'Momento da execução da atividade', id: '{{service_order.on_execution}}', type: 'raw_datetime' }
]

export const ALLOWED_FIELD_TYPES = ['date', 'datetime']
